
import { useAppSelector } from "app/redux/hooks";
import { IOrcamento } from "app/types/IOrcamento";
import { Vendedor } from "app/types/Vendedor";
import { tratamentoErroPadrao } from "app/use-cases";
import { removerVendedores } from "app/use-cases/orcamento/comissoes/vendedores";
import globalMU from "globalMU";
import React, { useState } from "react";
import { AdicionarVendedor } from "./AdicionarVendedor";

export type AdicionarVendedorContainerProps = {
    onDesativarIncluirVendedor: (semVendedoresAdiconados: boolean) => void;
}

export const AdicionarVendedoresContainer = (props: AdicionarVendedorContainerProps) => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    const [vendedores, setVendedores] = useState<Vendedor[]>(orcamento.Vendedores);

    const onExcluirVendedores = async (vendedores: Vendedor[]) => {
        try {
            globalMU.blockUI();
            const resultado = await removerVendedores(vendedores)
            if (!("HasErrors" in resultado) && resultado.Vendedores != null) {
                setVendedores([...resultado.Vendedores])
                globalMU.showSuccessMessage("Vendedor(es) excluído(s) com sucesso")
            } else {
                props.onDesativarIncluirVendedor(true);
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const incluirVendedor = () => {
        orcamento.Vendedores != null && orcamento.Vendedores != undefined && orcamento.Vendedores?.length != 0 ?
            props.onDesativarIncluirVendedor(false) : props.onDesativarIncluirVendedor(true)
    }

    return <AdicionarVendedor vendedoresAdicionar={vendedores}
        onIncluirVendedor={incluirVendedor}
        onExcluirVendedor={onExcluirVendedores}
        corSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
        textoSelecionadoAdicionar={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
    />

}

